import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Facebook, Instagram } from "lucide-react";
import logo from '../assets/logo.jpg';

// Version constant
const SITE_VERSION = "1.0.1";

const Footer = () => {
    const handleClick = () => {
        window.scrollTo(0, 0);
    };

    // Constants for social media
    const SOCIAL_ICON_SIZE = 40;
    const SOCIAL_LINKS = {
        youtube: "https://www.youtube.com/@PeerChargeEV",
        facebook: "https://www.facebook.com/profile.php?id=61580005347405",
        instagram: "https://www.instagram.com/peerchargeev/"
    };

    return (
        <footer id="contact" className="bg-gray-900 border-t border-gray-800">
            <div className="container mx-auto px-6 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center space-x-3 mb-4">
                            <img 
                                src={logo} 
                                alt="PeerchargeEV Logo" 
                                className="h-[25px] w-[25px] rounded-full"
                            />
                            <span className="text-2xl font-bold text-white">
                                Peercharge<span className="text-[#4ade80]">EV</span>
                            </span>
                        </div>
                        <p className="text-gray-400 max-w-md">
                            The future of EV charging is shared. Join our community to find convenient chargers or earn by sharing yours.
                        </p>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link 
                                    to="/#how-it-works" 
                                    className="text-gray-400 hover:text-brand-green"
                                    onClick={handleClick}
                                >
                                    How It Works
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/faq" 
                                    className="text-gray-400 hover:text-brand-green"
                                    onClick={handleClick}
                                >
                                    FAQs
                                </Link>
                            </li>
                            <li><Link to="/about" className="text-gray-400 hover:text-brand-green">About Us</Link></li>
                            <li><Link to="/blog" className="text-gray-400 hover:text-brand-green">Blog</Link></li>
                            <li><Link to="/calculators" className="text-gray-400 hover:text-brand-green">Calculators</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-white mb-4">Legal</h3>
                        <ul className="space-y-2">
                            <li><Link to="/terms" className="text-gray-400 hover:text-brand-green">Terms of Service</Link></li>
                            <li><Link to="/policy" className="text-gray-400 hover:text-brand-green">Privacy Policy</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-white mb-4">Contact Us</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/contact" className="text-gray-400 hover:text-brand-green">
                                    Get in Touch
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center">
                    <p className="text-gray-500">&copy; {new Date().getFullYear()} PeerchargeEV. All rights reserved.</p>
                    {/* Site version display */}
                    <span className="text-xs text-gray-600 mt-2 sm:mt-0 sm:ml-4">
                        Version: {SITE_VERSION}
                    </span>
                    <div className="flex space-x-4 mt-4 sm:mt-0">
                        <a 
                            href={SOCIAL_LINKS.youtube}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-500 hover:text-brand-green"
                        >
                            <Youtube size={SOCIAL_ICON_SIZE} />
                        </a>
                        <a 
                            href={SOCIAL_LINKS.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-500 hover:text-brand-green"
                        >
                            <Facebook size={SOCIAL_ICON_SIZE} />
                        </a>
                        <a 
                            href={SOCIAL_LINKS.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-500 hover:text-brand-green"
                        >
                            <Instagram size={SOCIAL_ICON_SIZE} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;